import React, { FC, ComponentProps } from "react";
import { cls } from "@wss/cls";

const Link: FC<ComponentProps<"a">> = ({ className, children, ...rest }) => (
  <a className={cls("flex group gap-2 items-center", className)} {...rest}>
    {children}
  </a>
);

export default Link;
